import { useEffect } from 'react';
import { useHomeViewModel } from './home.viewModel';
import { registerContext } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import { HomeView } from './Home.view';
import { useInfluencerId } from '@client/new/contexts/InfluencerIdContext';
import { useGetInfluencerQuery } from 'generated/graphql';
import { useOnboardingGuard } from '@client/new/pages/onboarding';
import { PATHS } from '@client/routes';
import { navigate } from '@client/new/helpers/history';

export const homeVM = registerContext('homeVM', useHomeViewModel);

export const HomePage = (p: { params: { influencerId?: string } }) => {
  const influencerId = useInfluencerId();
  const influencerQuery = useGetInfluencerQuery({
    variables: { id: influencerId },
    skip: !influencerId,
  });

  const creatorCreatedAt = influencerQuery.data?.creator?.createdAt ?? null;

  const guard = useOnboardingGuard(influencerId, creatorCreatedAt);

  useEffect(() => {
    if (!influencerQuery.data) return;

    if (guard.type === 'fetched' && guard.value.shouldRedirectToOnboarding) {
      const onboardingPath = p.params.influencerId
        ? PATHS.ONBOARDING_ADMIN(Number(p.params.influencerId))
        : PATHS.ONBOARDING;
      navigate(onboardingPath);
    }
  }, [guard, p.params.influencerId, influencerQuery.data]);

  return (
    <homeVM.ValueProvider
      params={p.params}
      renderer={(vm) => <HomeView {...vm} />}
    />
  );
};
